var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canRead || _vm.isTenant
    ? _c("Collapse", { attrs: { title: _vm.$t("tenantProjects.deposit") } }, [
        _c(
          "div",
          {
            staticClass: "projectControl__deposit",
            attrs: { slot: "content" },
            slot: "content",
          },
          [
            _c("DepositAmount", {
              ref: "depositAmount",
              attrs: {
                canUpdate: _vm.canUpdate,
                canNotifyAccounting: _vm.canNotifyAccounting,
                canRead: _vm.canRead,
                chequeFiles: _vm.chequeFiles,
              },
              on: { "dirty-state-change": _vm.notifyDirtyStateChange },
            }),
            _vm._v(" "),
            _vm.isShowRefund ? _c("hr") : _vm._e(),
            _vm._v(" "),
            _vm.isShowRefund
              ? _c("RefundAmount", {
                  ref: "refundAmount",
                  attrs: {
                    canUpdate: _vm.canUpdate,
                    canNotifyAccounting: _vm.canNotifyAccounting,
                  },
                  on: { "dirty-state-change": _vm.notifyDirtyStateChange },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isTenant && _vm.isShowDepositAttachment,
                    expression: "!isTenant && isShowDepositAttachment",
                  },
                ],
                staticClass: "deposit-upload",
              },
              [
                _c("hr"),
                _vm._v(" "),
                _vm.isShowDepositAttachment
                  ? _c("p", { staticClass: "title blod-p" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("tenantProjects.depositDocTitle")) +
                          "\n        "
                      ),
                      _c("span", { staticClass: "internal" }, [
                        _vm._v("(" + _vm._s(_vm.$t("internalUseOnly")) + ")"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.sourceId && _vm.canUpdate
                  ? _c("HkldDropzone", { attrs: { sourceId: _vm.sourceId } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sourceId
                  ? _c("EditAttachments", {
                      ref: "editAttachments",
                      attrs: {
                        sourceId: _vm.sourceId,
                        canDownloadAll: false,
                        canEdit: _vm.canUpdate,
                        canDelete: _vm.canUpdate,
                        getFilesList: _vm.getFilesList,
                        attachmentTypes: _vm.attachmentTypes,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }